import React from "react";
import { useLinkTargets } from "../context/LinkTargetsContext";
import { useLanguage } from "../context/LanguageContext";
import { linkifyText, buildPairs } from "../lib/linkify";

// Inline auto-linker: renders `text` with any article title/synonym linked to its wiki page.
export const AutoLink = ({ text, currentSlug, className, keyPrefix = "al" }) => {
  const { targets } = useLinkTargets();
  const { lang } = useLanguage();
  if (!text) return null;
  const pairs = buildPairs(targets, lang, currentSlug);
  return <span className={className}>{linkifyText(text, pairs, keyPrefix)}</span>;
};
